import React, { useContext, useState } from "react";
import DateAndTime from "../Components/DateAndTime";
import DateAndTimeMobileView from "../Components/DateAndTimeMobileView";

import {
  DateAndTimeRecievedProps,
  DateComponentProps,
} from "../DateAndTimeTypeProps";
import {
  DateFormatTypeEnum,
  RangeTypeEnum,
} from "../../../Common/Enums/EnumsTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
function DateAndTimeContainer({
  surveyAnswers,
  setSurveyAnswers,
  questionId,
  isPreview,
  questionObjVariable,
  surveyAnswersInfo,
}: DateAndTimeRecievedProps) {
  const { isMobile } = useContext(CheckResponsiveContext);

  //date change
  const handleChangeDate: DateComponentProps["handleChangeDate"] = (date) => {
    let dateInfoDup = { ...questionObjVariable[questionId].dateInfo };
    setSurveyAnswers((draft: DateAndTimeRecievedProps["surveyAnswers"]) => {
      draft[questionId] = draft[questionId] || {};
      if (date === null) {
        if (
          draft?.[questionId]?.comment?.length ||
          draft?.[questionId]?.uploads?.length
        ) {
          delete draft[questionId]["val"];
        } else {
          delete draft[questionId];
        }
      } else {
        if (
          dateInfoDup.dateFormat === DateFormatTypeEnum.DATE ||
          dateInfoDup.dateFormat === DateFormatTypeEnum.MONTH
        ) {
          draft[questionId]["val"] = {
            from: date,
            to: "",
            year: "",
          };
        } else {
          draft[questionId]["val"] = {
            from: "",
            to: "",
            year: date,
          };
        }
      }
    });
  };
  // handle from and to date changes
  const handleChangeFromAndTo: DateComponentProps["handleChangeFromAndTo"] = (
    date,
    type
  ) => {
    setSurveyAnswers((draft: DateAndTimeRecievedProps["surveyAnswers"]) => {
      draft[questionId] = draft[questionId] || {};
      const currentValues = draft[questionId]["val"] || { from: "", to: "" };
      if (type === RangeTypeEnum.FROM && date === null) {
        if (
          draft?.[questionId]?.comment?.length ||
          draft?.[questionId]?.uploads?.length
        ) {
          delete draft[questionId]["val"];
        } else {
          delete draft[questionId];
        }
      } else {
        let updatedValues =
          type === RangeTypeEnum.FROM
            ? { ...currentValues, from: date ?? "" }
            : { ...currentValues, to: date ?? "" };
        // validation for empty field in from,empty the to field also

        if (updatedValues?.from === null) {
          updatedValues = {
            ...currentValues,
            to: "",
          };
        }
        // validation for same values value in to if user onChanges the value after selecting to
        if (
          updatedValues?.to <= updatedValues.from &&
          updatedValues.from.toString().length &&
          updatedValues.to.toString().length
        ) {
          updatedValues = {
            ...updatedValues,
            to: "",
          };
        }
        draft[questionId]["val"] = updatedValues;
      }
    });
  };
  return (
    <>
      {isMobile ? (
        <DateAndTimeMobileView
          surveyAnswers={surveyAnswers}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          isPreview={isPreview}
          handleChangeDate={handleChangeDate}
          handleChangeFromAndTo={handleChangeFromAndTo}
        />
      ) : (
        <DateAndTime
          surveyAnswers={surveyAnswers}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          isPreview={isPreview}
          handleChangeDate={handleChangeDate}
          handleChangeFromAndTo={handleChangeFromAndTo}
        />
      )}
    </>
  );
}

export default DateAndTimeContainer;
